// extracted by mini-css-extract-plugin
export var standaloneTable = "_j9-0";
export var standaloneTableWithBodyFill = "_j9-1";
export var withExtraHeader = "_j9-2";